export default "__VITE_ASSET__CgbGHp$m__"